import { Breadcrumbs, Card, CardActionArea, CardContent, CardMedia, Link, Stack, Typography, } from '@mui/material';
import { useAuth } from './contexts/authContext';
import { useState } from 'react';
import InstitutionSummaryTable from './components/InstitutionSummaryTable';
import TopicSummaryTable from './components/TopicSummaryTable';
import PortfolioJournalExplorer from './components/PortfolioJournalExplorer';


function PortfolioPage() {

  const { userLoggedIn, isInstitutionalAccount,
    isPublisherAccount, isJournalistAccount, isPaidIndividualCustomer } = useAuth()

  const [showJournals, setShowJournals] = useState(false)
  const [showInstitutions, setShowInstitutions] = useState(false)
  const [showTopics, setShowTopics] = useState(false)
  const [showSelector, setShowSelector] = useState(true)
  const [selectedPortfolioTool, setSelectedPortfolioTool] = useState("")

  const resetPage = () => {
    setShowJournals(false)
    setShowInstitutions(false)
    setShowTopics(false)
    setShowSelector(true)
    setSelectedPortfolioTool("")
  };

  const showJournalsPage = () => {
    setShowJournals(true)
    setShowInstitutions(false)
    setShowTopics(false)
    setShowSelector(false)
    setSelectedPortfolioTool("Journals")
  };

  const showInstitutionsPage = () => {
    setShowJournals(false)
    setShowInstitutions(true)
    setShowTopics(false)
    setShowSelector(false)
    setSelectedPortfolioTool("Institutions")
  };

  const showTopicsPage = () => {
    setShowJournals(false)
    setShowInstitutions(false)
    setShowTopics(true)
    setShowSelector(false)
    setSelectedPortfolioTool("Topics")
  };


  return (
    <>
      {
        (userLoggedIn && (isPaidIndividualCustomer || isPublisherAccount || isJournalistAccount || isInstitutionalAccount)) &&
        <>
          {showSelector &&
            <div>
              <Stack direction="row" spacing={4} sx={{ textAlign: "center", justifyContent: "center", paddingBottom: 2, paddingLeft: 2, paddingRight: 2 }}>
                <Card sx={{ maxWidth: 345, minHeight: '100%' }}>
                  <CardActionArea onClick={() => showInstitutionsPage()} >
                    <CardMedia
                      component="img"
                      height="400"
                      image="/argos/static/images/cards/institutions.jpg"
                      alt="Institutions"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Institutions
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
                <Card sx={{ maxWidth: 345 }}>
                  <CardActionArea onClick={() => showJournalsPage()}  >
                    <CardMedia
                      component="img"
                      height="400"
                      image="/argos/static/images/cards/journals.jpg"
                      alt="Journals"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Journals
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
                <Card sx={{ maxWidth: 345 }}>
                  <CardActionArea onClick={() => showTopicsPage()}   >
                    <CardMedia
                      component="img"
                      height="400"
                      image="/argos/static/images/cards/topics.png"
                      alt="Topics"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Topics
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Stack>
            </div>
          }
          {!showSelector &&
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 2 }}>
              <Link underline="hover" color="inherit" href="/argos">
                Argos
              </Link>
              <Link
                underline="hover"
                color="inherit"
                onClick={() => resetPage()}
              >
                Explorer
              </Link>
              <Typography sx={{ color: 'text.primary' }}>{selectedPortfolioTool}</Typography>
            </Breadcrumbs>
          }
          {showJournals &&
            <PortfolioJournalExplorer />
          }
          {showInstitutions &&
            <InstitutionSummaryTable countryCode={undefined} />
          }
          {showTopics &&
            <TopicSummaryTable />
          }
        </>}
    </>
  );
}

export default PortfolioPage;
